module.exports = __webpack_public_path__ + "img/916.396aad85.png";